import { apiHeader, getData } from "../helpers/ApiHelper";
import { useUserDetailStore } from "../stores/userDetailStore";

// Personal Info Get API Call
export const viewPersonalInfo = async () => {
  const param = {};
  var response = await getData(
    "private/user/personal/information/detail",
    param,
    apiHeader(false)
  );

  if (
    String(response?.status) == "200" &&
    String(response?.data.status) == "200"
  ) {
    const data = response.data.data;
    useUserDetailStore.getState().setUserDetail(data);
  } else {
    console.log(response.data);
    console.log(response.data.message);
  }
};
